import { Injectable } from '@angular/core';
import { GroupBase } from '../models/blueprint.model';
import { EditingBoxConfigItem, RecordUpdateEmission } from '../models/report.model';
import { TemplateField } from '../models/template.model';
import { specialEditableFieldsArgs } from './editable-fields.const';

export interface TemplateFieldMapById {
  [fieldId: number]: TemplateField;
}

@Injectable()
export class EditableFieldsService {
  editableTemplateAttributes: TemplateFieldMapById = {};

  mapEditableFields(groupsToDisplay: GroupBase<TemplateField>[]): void {
    if (groupsToDisplay != null && !!groupsToDisplay.length) {
      const fields = (groupsToDisplay || []).reduce<TemplateField[]>((acc, group) => [...acc, ...group.fields], []);
      const editableTemplateAttributes: TemplateFieldMapById = fields.reduce((acc, field) => {
        if (this.editableTemplateAttributes[field.id] != null) {
          return acc;
        }
        const editableTemplateField: TemplateField = { ...field };
        if (Object.keys(specialEditableFieldsArgs()).includes(editableTemplateField.id.toString())) {
          editableTemplateField.displayFnArguments = editableTemplateField.displayFnArguments.filter(arg =>
            specialEditableFieldsArgs()[editableTemplateField.id].includes(arg.id)
          );
        }
        const fieldArguments = editableTemplateField.displayFnArguments.map(argument => ({
          field: argument.field,
          fieldUOM: argument.uomArgument ? argument.uomArgument.field : null,
          isUpdatable: argument.isUpdatable,
        }));
        const edpUpdateConf = fieldArguments
          .map(fieldArgument => {
            if (fieldArgument.isUpdatable) {
              return {
                labelMode: !!fieldArgument.fieldUOM ? 'associated' : 'normal',
                updatableFields: [fieldArgument.field, fieldArgument.fieldUOM].filter(element => !!element),
              };
            }
            return null;
          })
          .filter(element => !!element);
        let result = { ...acc };
        if (edpUpdateConf.length) {
          editableTemplateField.edpUpdateConf = edpUpdateConf as EditingBoxConfigItem[];
          result = { ...acc, [editableTemplateField.id]: editableTemplateField };
        }
        return result;
      }, {});
      this.editableTemplateAttributes = { ...this.editableTemplateAttributes, ...editableTemplateAttributes };
    }
  }

  generateRecordUpdateEmission(event: MouseEvent, id: number, record: { [key: string]: any }): RecordUpdateEmission {
    const fieldToUpdate = this.editableTemplateAttributes[id];
    let emittedObject: RecordUpdateEmission;
    if (fieldToUpdate != null) {
      emittedObject = {
        event,
        edpUpdateConf: fieldToUpdate.edpUpdateConf,
        record,
      };
    }
    return emittedObject;
  }
}
